import { cva } from "class-variance-authority"

/**
 * Badge core variants configuration.
 *
 * This configuration defines various badge styles.
 *
 * Variants:
 * - `variant`:
 * - `secondary`: Secondary badge style with background and text color.
 * - `destructive`: Destructive badge style for errors or warnings.
 * - `success`: Success badge style with green background.
 * - `warning`: Warning badge style with orange background.
 * - `outline`: Badge with border and text color.
 * - `noBackground`: Badge with no background, transparent border.
 *
 * Default Variants:
 * - `variant`: `secondary`
 */
export const badgeCoreVariants = cva(
  "ui-badge inline-flex items-center border font-medium",
  {
    variants: {
      variant: {
        secondary: "border-transparent bg-secondary text-secondary-foreground",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground",
        warning: "border-transparent bg-orange-100 text-orange-800",
        success: "border-emerald-500 bg-emerald-100 text-emerald-800",
        outline: "text-foreground bg-background",
        noBackground: "border-transparent text-primary-foreground shadow",
      },
      size: {
        tiny: "text-xs px-1.5 max-h-4 rounded-xs gap-1",
        xs: "text-xs px-1.5 rounded-xs gap-1",
        sm: "text-xs px-1.5 py-px max-h-5 rounded-xs gap-1",
        md: "text-sm px-2 rounded-sm gap-1.5",
        lg: "text-sm px-2 py-px max-h-6 rounded-sm gap-1.5",
        xl: "text-base px-3 py-px rounded-md gap-2",
      },
      pill: {
        true: "!rounded-full",
        false: "",
      },
    },
    defaultVariants: {
      variant: "secondary",
      size: "md",
      pill: false,
    },
  },
)
